import { Injectable } from '@angular/core';
import firebase from 'firebase/app';
import { AngularFirestore } from "angularfire2/firestore";

@Injectable()
export class AdverseEventsProvider {

  constructor(
    private afs: AngularFirestore
  ) {}

  listAdverseEventsByProgram(program_id)  {
    return this.afs.collection<any>(`program/${program_id}/adverseevents`, ref =>
      ref.orderBy("createdAt", "desc")
    );
  }

  listAdverseEventsByPatient(program_id, patient_id)  {
    return this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/adverseevent_history`, ref =>
      ref.orderBy("createdAt", "desc")
    );
  }

  getAdverseEvent(program_id: string, adverseevent_id: string) {
    return this.afs.collection<any>(`program/${program_id}/adverseevents/${adverseevent_id}`);
  }

  addAdverseEvents(program_id: string, patient_id: string, adverseevent: any, user: any) {
    const doc_id = this.afs.createId();
    const createdAt = firebase.firestore.FieldValue.serverTimestamp();
    const createdBy = user;
    const updatedAt = createdAt;
    const updatedBy = user;
    adverseevent = { id: doc_id, createdAt, createdBy, updatedAt, updatedBy, ...adverseevent };
    var batch = this.afs.firestore.batch();
    batch.set(this.afs.collection<any>(`program/${program_id}/adverseevents`).doc(doc_id).ref, adverseevent);
    batch.set(this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/adverseevent_history`).doc(doc_id).ref, adverseevent);
    return batch.commit();
  }

  updateAdverseEvents(program_id: string, patient_id: string, adverseevent_id: string, adverseevent: any, user: any)  {
    const updatedAt = firebase.firestore.FieldValue.serverTimestamp();
    const updatedBy = user;
    adverseevent = { updatedAt, updatedBy, ...adverseevent };
    var batch = this.afs.firestore.batch();
    batch.update(this.afs.collection<any>(`program/${program_id}/adverseevents`).doc(adverseevent_id).ref, adverseevent);
    batch.update(this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/adverseevent_history`).doc(adverseevent_id).ref, adverseevent);
    return batch.commit();
  }

  deleteAdverseEvent(program_id: string, patient_id: string, adverseevent_id: string)  {
    var batch = this.afs.firestore.batch();
    batch.delete(this.afs.collection<any>(`program/${program_id}/adverseevents`).doc(adverseevent_id).ref);
    batch.delete(this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/adverseevent_history`).doc(adverseevent_id).ref);
    return batch.commit();
  }
}


// WEBPACK FOOTER //
// ./src/providers/adverse-events/adverse-events.ts